// src/features/inventory/utils/inventoryConstants.js

export const UNIT_TRANSLATIONS = {
  count: "عدد",
  package: "بسته",
  weight: "کیلوگرم",
  length: "متر",
  area: "متر مربع",
  litr: "لیتر",
  volume: "متر مکعب",
};

export const EXCEL_HEADERS = {
  id: "شناسه",
  name: "نام کالا",
  product_code: "کد کالا",
  brand: "برند",
  category: "دسته‌بندی",
  price: "قیمت",
  stock: "موجودی",
  discount_percent: "درصد تخفیف",
  min_order: "حداقل سفارش",
  max_order: "حداکثر سفارش",
  order_multiple: "مضرب سفارش",
  is_active: "وضعیت کالا",
  inventory_is_active: "وضعیت موجودی",
};

// نگاشت معکوس فارسی به فیلدهای انگلیسی جهت پارس کردن آسان اکسل
export const EXCEL_HEADER_MAP = {
  "شناسه": "id",
  "نام کالا": "name",
  "نام": "name",
  "کد کالا": "product_code",
  "برند": "brand",
  "دسته‌بندی": "category",
  "قیمت": "price",
  "موجودی": "stock",
  "درصد تخفیف": "discount_percent",
  "حداقل سفارش": "min_order",
  "حداکثر سفارش": "max_order",
  "مضرب سفارش": "order_multiple",
  "وضعیت کالا": "is_active",
  "وضعیت موجودی": "inventory_is_active",
};
